import {
  DEFAULT_RESPECT_USER_MOTION_PREFERENCE,
  REDUCED_MOTION_QUERY,
} from './constants';

//////////////////////////////////////////////////
//// Function:
//////////////////////////////////////////////////
/**
 * // Function: ユーザー環境が「動きを減らす」設定かどうかを判定
 */
export function prefersReducedMotion(): boolean
{
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
  {
    return false;
  }

  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

/**
 * // Function: respectUserMotionPreference の未指定時デフォルトを解決
 */
export function resolveRespectUserMotionPreference(respect_user_motion_preference?: boolean): boolean
{
  return respect_user_motion_preference ?? DEFAULT_RESPECT_USER_MOTION_PREFERENCE;
}

/**
 * // Function: 現在の環境でアニメーションを実行してよいかを判定
 */
export function canUseMotion(respect_user_motion_preference: boolean = DEFAULT_RESPECT_USER_MOTION_PREFERENCE): boolean
{
  if (!respect_user_motion_preference)
  {
    return true;
  }

  return !prefersReducedMotion();
}

/**
 * // Function: 現在の環境で即時切り替えに寄せるべきかを判定
 */
export function shouldReduceMotion(respect_user_motion_preference: boolean = DEFAULT_RESPECT_USER_MOTION_PREFERENCE): boolean
{
  return !canUseMotion(respect_user_motion_preference);
}
